import axios from 'axios'
import publish from './pubilshSet'
import connom from './common'
import store from '@/store'
// import avatar from '@/assets/loading.gif'
// axios.defaults.timeout = 30000 // 超时响应
// axios.defaults.baseURL = publish.baseUrl // 根目录地址
axios.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    // config.data = JSON.stringify(config.data)
    config.headers = {
      // 'token': store.getters.token,
      'token': window.localStorage.getItem('huozhewang_token'),
      'Accept-Language': window.localStorage.getItem('language') || 'zh-CN'
    }
    if (config.url.indexOf('?') >= 0) {
      config.url = config.url + '&t=' + new Date().getTime()
    } else {
      config.url = config.url + '?t=' + new Date().getTime()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
function resetUrl (msg) {
  if (msg === '用户未登录') {
    // const redirUrl = window.location.href
    // window.location.href = 'http://speaker-test.gileadchina.cn/account/login?redirect=' + encodeURIComponent(redirUrl)
    window.location.href = publish.baseUrl + 'login'
    // console.log('http://speaker-test.gileadchina.cn/account/login?redirect=' + encodeURIComponent(redirUrl))
  }
}
export default {
  get (url, type) {
    let newBase = publish.baseUrl
    if (type === 1) {
      newBase = publish.fileBaseUrl
    }
    return new Promise((resolve, reject) => {
      axios.get(newBase + url)
        .then(response => {
          if (response.data.response === '000000') {
            resolve(response.data)
          } else {
            resetUrl(response.data.message)
            if (response.data.code === 401 || response.data.code === 402) {
              connom.alertTips({
                type: 'error',
                title: '错误:',
                content: response.data.message,
                stayTime: 5
              })
              window.location.href = publish.myBaseUrl + '/login'
              return
            }
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.message,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          if (err.response.status === 401 || err.response.status === 402) {
            window.location.href = publish.baseUrl + '/login'
            return
          }
          connom.alertTips({
            type: 'error',
            title: '错误:',
            content: '服务器报错',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  getFile (url) {
    disabledAllButton(false)
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          disabledAllButton(false)
          if (err.response.status === 401 || err.response.status === 402) {
            window.location.href = publish.baseUrl + '/login'
            return
          }
          connom.alertTips({
            type: 'error',
            title: '错误:',
            content: '服务器报错',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  post (url, data, type) {
    let newBase = publish.baseUrl
    if (type === 1) {
      newBase = publish.fileBaseUrl
    }
    disabledAllButton(false)
    return new Promise((resolve, reject) => {
      axios.post(newBase + url, data)
        .then(response => {
          disabledAllButton(false)
          // console.log(response)
          if (response.data.response === '000000') {
            resolve(response.data)
          } else {
            resetUrl(response.data.message)
            if (response.data.code === 401 || response.data.code === 402) {
              connom.alertTips({
                type: 'error',
                title: '错误:',
                content: response.data.msg,
                stayTime: 5
              })
              window.location.href = publish.myBaseUrl + '/login'
              return
            }
            connom.showTips(response.data.message)
          }
        })
        .catch(err => {
          disabledAllButton(false)
          if (err.response.status === 401 || err.response.status === 402) {
            window.location.href = publish.baseUrl + '/login'
            return
          }
          connom.showTips('服务器报错')
          reject(err)
        })
    })
  },
  put (url, data) {
    disabledAllButton(false)
    return new Promise((resolve, reject) => {
      axios.put(url, data)
        .then(response => {
          disabledAllButton(false)
          if (response.data.code === 0) {
            resolve(response.data)
          } else {
            resetUrl(response.msg)
            if (response.data.code === 401 || response.data.code === 402) {
              connom.alertTips({
                type: 'error',
                title: '错误:',
                content: response.data.msg,
                stayTime: 5
              })
              window.location.href = publish.myBaseUrl + '/login'
              return
            }
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.msg,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          disabledAllButton(false)
          if (err.response.status === 401 || err.response.status === 402) {
            window.location.href = publish.baseUrl + '/login'
            return
          }
          connom.showTips('服务器报错')
          reject(err)
        })
    })
  },
  del (url) {
    return new Promise((resolve, reject) => {
      axios.delete(url)
        .then(response => {
          if (response.data.code === 0) {
            resolve(response.data)
          } else {
            if (response.data.code === 401 || response.data.code === 402) {
              connom.alertTips({
                type: 'error',
                title: '错误:',
                content: response.data.msg,
                stayTime: 5
              })
              window.location.href = publish.myBaseUrl + '/login'
              return
            }
            connom.alertTips({
              type: 'error',
              title: '错误:',
              content: response.data.msg,
              stayTime: 5
            })
          }
        })
        .catch(err => {
          if (err.response.status === 401 || err.response.status === 402) {
            window.location.href = publish.baseUrl + '/login'
            return
          }
          connom.alertTips({
            type: 'error',
            title: '错误:',
            content: '服务器报错',
            stayTime: 5
          })
          reject(err)
        })
    })
  },
  asyncGet (url, type) {
    let newBase = publish.baseUrl
    if (type === 1) {
      newBase = publish.fileBaseUrl
    }
    var p = new Promise((resolve, reject) => {
      axios.get(newBase + url).then(msg => {
        resolve(msg.data.data)
      }).catch(err => {
        if (err.response.status === 401 || err.response.status === 402) {
          window.location.href = publish.baseUrl + '/login'
        }
      })
    })
    console.log(p)
    return p
  },
  asyncGetTwo (url) {
    let newBase = publish.baseUrl
    var p = new Promise((resolve, reject) => {
      axios.post(newBase + url).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  asyncPost (url, data, type) {
    let newBase = publish.baseUrl
    if (type === 1) {
      newBase = publish.fileBaseUrl
    }
    var p = new Promise((resolve, reject) => {
      axios.post(newBase + url, data).then(msg => {
        resolve(msg.data.data)
      })
    })
    return p
  },
  getToken (url, data) {
    let newBase = publish.baseUrl
    return new Promise((resolve, reject) => {
      // coverGif()
      axios.get(newBase + url, data)
        .then(response => {
          // disCover()
          // alert(response.data.code, url)
          // if (response.data.code === 401) {
          //   window.localStorage.removeItem('HLToken')
          //   window.location.href = '/'
          // }
          resolve(response.data)
        })
        .catch(err => {
          // disCover()
          // alert(err)
          if (err.response.status === 401 || err.response.status === 403) {
            window.localStorage.removeItem('mdTTToken')
            window.sessionStorage.removeItem('MemberInfo')
            window.location.href = publish.baseUrl + ''
          } else {
            connom.showTips(err.response.data.msg)
          }
          reject(err)
        })
    })
  }
}
function disabledAllButton (type) {
  let buttonList = document.querySelectorAll('.postDidabaled')
  for (let i = 0; i < buttonList.length; i++) {
    buttonList[i].disabled = type
  }
}
